import { Box, Stack, Typography } from '@mui/material'
import AddOutlinedIcon from '@mui/icons-material/AddOutlined'
import ViewKanbanOutlinedIcon from '@mui/icons-material/ViewKanbanOutlined'
import LoadingButton from '@mui/lab/LoadingButton'
import { useDispatch } from 'react-redux'
import { setBoards } from '../redux/features/boardSlice'
import { useNavigate } from 'react-router-dom'
import boardApi from '../api/boardApi'
import { useState } from 'react'
import { tokens } from '../theme'
import { errorMessage } from '../utils/errors'
import { useToast } from '../components/common/ToastProvider'

const Home = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const toast = useToast()
  const [loading, setLoading] = useState(false)

  const createBoard = async () => {
    setLoading(true)
    try {
      const res = await boardApi.create()
      dispatch(setBoards([res]))
      navigate(`/boards/${res.id}`)
    } catch (err) {
      toast.error(errorMessage(err, 'Could not create the board.'))
    } finally {
      setLoading(false)
    }
  }

  return (
    <Box
      sx={{
        flexGrow: 1,
        display: 'grid',
        placeItems: 'center',
        px: { xs: 3, md: 6 },
        py: 8
      }}
    >
      <Box
        sx={{
          width: '100%',
          maxWidth: 520,
          p: { xs: 3, md: 5 },
          borderRadius: 4,
          border: '1px dashed',
          borderColor: 'divider',
          backgroundColor: 'rgba(19, 24, 32, 0.6)',
          textAlign: 'center'
        }}
      >
        <Box
          sx={{
            width: 56,
            height: 56,
            mx: 'auto',
            mb: 3,
            borderRadius: 3,
            display: 'grid',
            placeItems: 'center',
            color: 'primary.main',
            backgroundColor: tokens.accentSoft
          }}
        >
          <ViewKanbanOutlinedIcon />
        </Box>

        <Typography variant='h3' sx={{ mb: 1.5 }}>
          Start with a board
        </Typography>
        <Typography color='text.secondary' sx={{ mb: 4, mx: 'auto', maxWidth: 380 }}>
          A board holds your sections, and each section holds its tasks. Create one and we
          will take you straight to it.
        </Typography>

        <LoadingButton
          variant='contained'
          size='large'
          startIcon={<AddOutlinedIcon />}
          loading={loading}
          onClick={createBoard}
        >
          Create a board
        </LoadingButton>

        <Stack direction='row' spacing={1} justifyContent='center' sx={{ mt: 2.5 }}>
          <Typography variant='caption' color='text.disabled'>
            You can rename it and add an icon right after.
          </Typography>
        </Stack>
      </Box>
    </Box>
  )
}

export default Home
